import React, { useState } from 'react'
import { BtnV2, Link, l, Modal } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { openManageProfilesModal as openManageProfilesModalAction } from 'common/core/actions/uiActions'
import { MetaDeletionPayload } from 'common/core/components/NotifyBar/NotifyInterfaces'

import cm from './common.module.css'

interface MetaDeletionSignInWithFallbackNotificationProps {
  day: 0 | 15 | 27
  data: MetaDeletionPayload
}

export const MetaDeletionSignInWithFallbackNotification = ({
  day,
  data,
}: MetaDeletionSignInWithFallbackNotificationProps) => {
  const dispatch = useAppDispatch()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleToggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }
  const openManageProfilesModal = () => {
    setIsModalOpen(false)
    dispatch(openManageProfilesModalAction())
  }

  return (
    <>
      <span className="m-r-xs">
        {l.translate('Facebook sign-in will be removed on {deletion_date}', {
          deletion_date: l.date(data.deletion_date),
        })}
      </span>

      <Link className={cm.link} onClick={handleToggleModal}>
        {l.translate('Read more')}
      </Link>

      <Modal
        width={460}
        title={l.translate('Facebook sign-in will be removed')}
        open={isModalOpen}
        buttons={[
          <BtnV2 variant="primary" onClick={openManageProfilesModal}>
            {l.translate('Review sign-in options')}
          </BtnV2>,
        ]}
        onRequestClose={handleToggleModal}
      >
        {day === 0 && (
          <>
            <p className="font-medium">
              {l.translate('Removal date: {deletion_date}.', {
                deletion_date: l.date(data.deletion_date),
              })}
            </p>
            <p>
              {l.translate(
                'Meta asked us to delete data tied to your Facebook profile. You can still sign in with your email or another sign-in method.',
              )}
            </p>
          </>
        )}

        {day === 15 && (
          <>
            <p className="font-medium">
              {l.translate('Removal date: {deletion_date}.', {
                deletion_date: l.date(data.deletion_date),
              })}
            </p>
            <p>
              {l.translate(
                'Nothing has changed since our first notice. You can still sign in with your email or another sign-in method.',
              )}
            </p>
          </>
        )}

        {day === 27 && (
          <>
            <p className="font-medium">
              {l.translate('Final notice. Removal date: {deletion_date}.', {
                deletion_date: l.date(data.deletion_date),
              })}
            </p>
            <p>{l.translate('You can still sign in with your email or another sign-in method.')}</p>
          </>
        )}
      </Modal>
    </>
  )
}
